<script setup>
import { computed } from 'vue';
import { usePortalContentAndDesignStore } from "../../../../../stores/partners/portalContentAndDesignStore";
import EditableTextField from "../../../portal-editable-fields/EditableTextField.vue";
import { isCustomColor } from "../../../../../helpers/common";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const layoutStyle = computed(() => portalContentAndDesignStore.portalLayoutSettings.portal_layout_layout_style);
const layout = computed(() => portalContentAndDesignStore.portalLayoutSettings.portal_layout_layout);
const navigationColor = computed(() => portalContentAndDesignStore.portalLayoutSettings.portal_layout_navigation_color);
const linkColor = computed(() => portalContentAndDesignStore.portalLayoutSettings.portal_layout_link_color);
const corners = computed(() => portalContentAndDesignStore.portalLayoutSettings.portal_layout_layout_corners);
const currentStep = computed(() => portalContentAndDesignStore.profilePageSettings.onboarding_step || 1);

const isDarkNav = computed(() => navigationColor.value === 'brand' || navigationColor.value === 'black');

const steps = [
    {
        key: 'step_1',
        title: 'portal_translation_onboarding_step_1',
        description: 'portal_translation_onboarding_welcome',
    },
    {
        key: 'step_2',
        title: 'portal_translation_onboarding_step_2',
        description: 'portal_translation_onboarding_my_profile',
    },
    {
        key: 'step_3',
        title: 'portal_translation_onboarding_step_3',
        description: 'portal_translation_onboarding_partner_profile',
    },
];

// Class helpers
function getTextColor() {
    if (layoutStyle.value === 'none' && layout.value === 'one' && isDarkNav.value) return 'text-white';
    return isCustomColor(linkColor.value) ? 'custom-link' : `text-${linkColor.value || 'teal-600'}`;
}

function getBorderColor() {
    if (layoutStyle.value === 'none' && layout.value === 'one' && isDarkNav.value) return 'border-white';
    return isCustomColor(linkColor.value) ? 'custom-border' : `border-${linkColor.value || 'teal-600'}`;
}

function stepClass(index) {
    const isCompleted = currentStep.value > index + 1;
    const isCurrent = currentStep.value === index + 1;

    return [
        'group pl-4 py-2 flex flex-col md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4',
        getBorderColor(),
        (isCompleted || isCurrent) ? '' : 'opacity-75'
    ];
}
</script>

<template>
    <div
        :class="[
          layoutStyle !== 'none' && layout === 'one' ? 'flex flex-col bg-white px-10 pt-10 mb-10' : '',
          layoutStyle !== 'none' && layout === 'one' ? layoutStyle : '',
          layoutStyle !== 'none' && layout === 'one' ? corners : ''
        ]"
    >
        <nav aria-label="Progress" class="mb-10">
            <ol role="list" class="space-y-4 md:flex md:space-y-0 md:space-x-8">
                <li v-for="(step, index) in steps" :key="step.key" class="md:flex-1">
                    <a href="#" :class="stepClass(index)">
                        <editable-text-field
                            text-type="span"
                            class="text-xs font-semibold tracking-wide uppercase"
                            :class="getTextColor()"
                            v-model="portalContentAndDesignStore.translationSettings[step.title]"
                        />
                        <editable-text-field
                            text-type="span"
                            class="text-sm font-medium"
                            :class="getTextColor()"
                            v-model="portalContentAndDesignStore.translationSettings[step.description]"
                        />
                    </a>
                </li>
            </ol>
        </nav>
    </div>
</template>
